import { getCountryDrawParams } from './draw-params'
import { DRAW_CONSTS } from '../constants-canvas'
import { CHALLENGES, CHALLENGES_COLORS, Challenge, ChallengesMap } from '../../../lib/constants'

type DrawVerticalBarsOptions = {
  ctx: CanvasRenderingContext2D
  data: ChallengesMap<number>
  x: number
  width: number
  height: number
}

export function drawBars({ ctx, data, x, width, height }: DrawVerticalBarsOptions) {
  const drawParams = getCountryDrawParams(data, height)
  const { position: cTop, length: cHeight } = drawParams

  CHALLENGES.forEach((challenge) => {
    ctx.fillStyle = CHALLENGES_COLORS[challenge]
    ctx.fillRect(x, cTop[challenge], width, cHeight[challenge])
  })

  ctx.fillStyle = 'white'
  CHALLENGES.forEach((challenge, i) => {
    if (i === 0) return
    ctx.fillRect(
      x,
      cTop[challenge] - DRAW_CONSTS.RECT_SEPARATOR_HEIGHT / 2,
      width,
      DRAW_CONSTS.RECT_SEPARATOR_HEIGHT
    )
  })
}

export const MOBILE_BREAKPOINT = 1024
